import React, { useState } from 'react';
import * as styles from './container.module.sass';
import { DoubleTextContainer } from '../../organism/DoubleTextContainer';
import { Card } from '../Card';
import { Color } from '../../enums/color';
import { Image } from '../../atoms/image';
import { Button } from '../../atoms/button';

export const VideoSection = (props: any) => {
  const [showVideoPicture, setVideoPicture] = useState(true);

  return (
    <Card color={Color.SECONDARY} className={styles.video_section}>
      <h2 className={styles.secondary_heading}>{props.title}</h2>
      <div className={styles.content}>
        {showVideoPicture ? (
          <div className={styles.video_preview_wrapper}>
            <Image
              srcs={[{ src: `/public-assets/img/shared/video.webp`, type: 'image/webp' }]}
              src={`/public-assets/img/shared/video.webp`}
              alt={'video_preview'}
              className={styles.video_container}
            />
            <Button
              onClick={() => setVideoPicture(false)}
              color={Color.EMPTYALL}
              text={
                <Image
                  className={styles.preview_button_img}
                  srcs={[{ src: '/public-assets/img/badges/youtube.svg', type: 'image/svg' }]}
                  src={`/public-assets/img/badges/youtube.svg`}
                  alt={'video_preview'}
                />
              }
              className={styles.preview_button}
            />
          </div>
        ) : (
            
            
          <iframe
            className={styles.video_container}
            src={props.src}
            title={props.title}
            frameBorder="0"
            allow="autoplay"
            allowFullScreen
          />
        )}
        <DoubleTextContainer video_info={props.videoInfo} />
      </div>
    </Card>
  );
};
